import { createContext, useContext } from "react";

export interface InviteConfigType {
  mutiFlag: boolean;
  isWhiteListUser: boolean;
  isKol: boolean;
  isMultilevel: boolean;
  isKoreanKol: boolean;
}

export const InviteConfigContext = createContext<InviteConfigType>({
  mutiFlag: false,
  isWhiteListUser: false,
  isKol: false,
  isMultilevel: false,
  isKoreanKol: false,
});

export const useInviteConfig = () => useContext(InviteConfigContext);
